import { useMemo, useState } from "react";
import { Button } from "../../../components/Button";
import { ReactComponent as AlertIcon } from "../../../assets/icons/Alert.svg";

import { ClientQuizFormType } from "./ClientQuiz";
import { SelectInput } from "../../../components/SelectInput";
import { acceptedInsurances } from "../../../constant";
import { zipCodes } from "../../../assets/data/zip_codes";
import { TextInput } from "../../../components/TextInput";

export function Step4({
  onNext,
  clientQuizForm: form,
  setClientQuizForm: setForm
}: {
  onNext: () => void;
  clientQuizForm: ClientQuizFormType;
  setClientQuizForm: (value: ClientQuizFormType) => void;
}) {
  const [errors, setErrors] = useState({} as any);
  const [error, setError] = useState<string>("");
  const [saving, setSaving] = useState(false);

  const isZipValid = (code: string) => code && (code.trim().length === 5 && !isNaN(parseInt(code, 10)) && !!zipCodes[code])
  const [zipCity, zipState, zipFullState] = useMemo(() => {
    return form.zipCode && isZipValid(form.zipCode) ? [zipCodes[form.zipCode]?.city, zipCodes[form.zipCode]?.state_short, zipCodes[form.zipCode]?.state] : [undefined, undefined, undefined];
  }, [form.zipCode]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm({ ...form, [name]: value } as ClientQuizFormType);
  };

  const validateAndNext = async (e) => {
    e.preventDefault();

    let newErrors = {};

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return
    }

    onNext();
  };

  const disabled = useMemo(() => {
    return !form.insuranceProvider
      || (form.insuranceProvider === 'OTHER' && (!form.otherInsuranceProvider || form.otherInsuranceProvider.trim().length < 3))
  }, [form]);

  return (
    <>
      <div className="bg-white p-8 rounded-[16px]">
        <form className="mt-4 flex flex-col gap-[22px]" onSubmit={validateAndNext}>
          <div className="md:flex-row items-center gap-3">
            <div className="flex-1 w-full flex flex-col gap-1.5 mb-5">
            <div className="text-primary font-bold">4.</div>
              <label className="text-lg text-black/80">
                What insurance provider do you have?
              </label>
              <SelectInput
                name="insuranceProvider"
                disabledOptionText="Select your insurance provider"
                data={
                  [
                    ...acceptedInsurances.filter(insurance => insurance.states.includes(zipFullState)),
                    { value: 'OTHER', label: 'Other' }
                  ]
                }
                value={form.insuranceProvider}
                onChange={handleChange}
              />
              {errors.insuranceProvider && (
                <div className="text-red-500 text-xs font-medium">
                  {errors.insuranceProvider}
                </div>
              )}
            </div>
            {form.insuranceProvider === 'OTHER' ? <div className="flex-1 w-full flex flex-col gap-1.5">
              <label className="text-lg text-black/80">
                Other: Please specify the name of your insurance provider
              </label>
              <TextInput
                name="otherInsuranceProvider"
                value={form.otherInsuranceProvider}
                onChange={handleChange}
                placeholder="Please specify"
                maxLength={200}
              />
              {errors.otherInsuranceProvider && (
                <div className="text-red-500 text-xs font-medium">
                  {errors.otherInsuranceProvider}
                </div>
              )}
            </div> :
              <div />
            }

          </div>

          <div className="mt-7">
            {error && (
              <div className="text-red-500 text-xs font-medium mb-4 flex items-center gap-1">
                <AlertIcon /> {error}
              </div>
            )}
            <Button
              type="submit"
              variant="primary"
              className="!rounded-full w-full"
              disabled={disabled || saving}
              loading={saving}
              onClick={validateAndNext}
            >
              Next
            </Button>
          </div>
        </form>
      </div>

    </>
  );
}
